/**
 * Language Configuration
 * 
 * This file controls which languages are enabled in the application.
 * Simply set `enabled: true` or `enabled: false` to enable/disable a language.
 * 
 * To add a new language:
 * 1. Add the language object below
 * 2. Create translation files in frontend/src/locales/{code}.json
 * 3. Create translation files in backend/src/locales/{code}/translation.json
 * 4. Import and add to i18n.js resources
 */

export const languages = {
  en: {
    code: 'en',
    name: 'English',
    nativeName: 'English',
    flag: '🇬🇧',
    dir: 'ltr',
    enabled: true
  },
  ar: {
    code: 'ar',
    name: 'Arabic',
    nativeName: 'العربية',
    flag: '🇸🇦',
    dir: 'rtl',
    enabled: true
  },
  fr: {
    code: 'fr',
    name: 'French',
    nativeName: 'Français',
    flag: '🇫🇷',
    dir: 'ltr',
    enabled: false
  }
};

// Get only enabled languages
export const getEnabledLanguages = () => {
  return Object.values(languages).filter(lang => lang.enabled);
};

// Get language by code
export const getLanguageByCode = (code) => {
  return languages[code] || languages.en;
};

// Get default language (first enabled language, or 'en')
export const getDefaultLanguage = () => {
  const enabled = getEnabledLanguages();
  return enabled.length > 0 ? enabled[0].code : 'en';
};

// Get supported language codes
export const getSupportedLanguageCodes = () => {
  return getEnabledLanguages().map(lang => lang.code);
};
